/**
 * @desc web 资源管理器http文件上传
 * @author xos
 * @version 2.0.0
 */

import { v4 as uuidv4 } from 'uuid'
import EventEmitter from '@remote/utils/event-emitter'
import { HEZI_API_URL, isSeparateAccount } from '@remote/api/config'
import { FileSlicer } from './helper'
// import { STATUS } from './index.d'
import Events from './enum'

enum STATUS {
  expried = -2,
  cancel = -1,   // 取消
  init,          // 初始中
  completed,     // 已完成
  process = 3,   // 处理中
  suspend        // 暂停
}

type TParams = {
  file: File
  chunkSize: number
  path: string
  deviceId: string
  token: string
  attachmentId: string
}

/**
 * http文件上传器
 * @class
 * @constructor
 * @param { File } _file - 上传文件对象
 * @param { number } _chunkSize - 切片大小
 * @param { string } _path - 文件落盘路径
 */

class HttpUploader extends EventEmitter {
  private _status: STATUS
  private xhr: XMLHttpRequest | null
  /**
    * constructor description
    * @param  { File } file - 上传文件对象
    * @param  { number } chunkSize - 文件分片大小
    */

  constructor () {
    super(
      [
        Events.UploadTaskError,
        Events.UploadTaskTransitServerProgress,
        Events.UploadTaskTransitServerCompleted,
        Events.UploadTaskDeviceReceiveProgress,
        Events.UploadTaskDeviceReceiveCompleted,
      ],
    )
    this._status = STATUS.init
    this.xhr = null
  }

  // 开始
  start (params: TParams) {
    this.httpUploadFile(params)
  }
  // 重传
  resume (params: TParams) {
    this._status = STATUS.process
    this.httpUploadFile(params)
  }

  async httpUploadFile (params: TParams) {
    const session_id = uuidv4()
    const { chunkSize, file, path, deviceId, token, attachmentId } = params
    const fs = new FileSlicer({ file, chunkSize, baseSlice: 0 })
    const _chunkTotal = fs.slices

    const uploadFile = (chunk: Blob, i: number) => {
      return new Promise((resolve, reject) => {
        const fd = new FormData()
        const xhr = new XMLHttpRequest()
        this.xhr = xhr
        console.log('i >>>', i)
        const onreadystatechange = () => {
          if ([STATUS.cancel, STATUS.suspend].includes(this._status)) return

          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              const resp = JSON.parse(xhr.responseText)
              if (resp && resp.code === 200) {
                if (i === _chunkTotal) {
                  console.log('upload finished')
                  this.trigger(Events.UploadTaskTransitServerCompleted, attachmentId, xhr.responseText.toString())
                  setTimeout(() => {
                    this.trigger(Events.UploadTaskDeviceReceiveCompleted, attachmentId, xhr.responseText.toString())
                  }, 100)

                } else {
                  console.log('i', i, '_chunkTotal', _chunkTotal)
                  this.trigger(Events.UploadTaskTransitServerProgress, attachmentId, i / _chunkTotal)
                  this.trigger(Events.UploadTaskDeviceReceiveProgress, attachmentId, i / _chunkTotal)
                  // UploadEventBus.trigger(Events.UploadTaskTransitServerProgress, i / _chunkTotal)
                }
                resolve(xhr.responseText)
              } else {
                console.log('resp 1', resp, xhr.responseText)
                this.trigger(Events.UploadTaskError, attachmentId, `服务器连接异常[${resp.code}]`)
                reject(resp.code)
                console.log('responseText', resp.msg, xhr.responseText)
              }
            } else {
              console.log('resp 2', xhr)
              reject(`上传服务异常，请稍后重试[${xhr.status}]`)
              this.trigger(Events.UploadTaskError, attachmentId, `服务器连接异常[${xhr.status}]`)
            }
          }
        }

        const ontimeout = function () {
          console.error(`The upload request for timed out.${file.name}`)
        }
        console.log('token', token)
        fd.append('device_id', deviceId)
        fd.append('file_name', file.name)
        fd.append('file_path', path)
        fd.append('file_size', String(file.size))
        fd.append('session_id', session_id)
        fd.append('token', token)
        fd.append('data', chunk)
        fd.append('index', String(i - 1))
        fd.append('chunk_size', String(chunkSize))
        //设置请求头
        xhr.timeout = 2 * 60 * 1000
        xhr.open('POST', `${HEZI_API_URL}/upload`)
        if (isSeparateAccount) xhr.setRequestHeader('X-Reg-From','xbase')
        xhr.onreadystatechange = onreadystatechange
        xhr.ontimeout = ontimeout
        xhr.onerror = reject
        xhr.send(fd)
      })
    }

    for (let i = 0; i < _chunkTotal; ++i) {
      if ([STATUS.cancel, STATUS.suspend].includes(this._status)) break
      try {
        const chunk = fs.getNextSlice() as Blob
        await uploadFile(chunk, i + 1)
      } catch (err) {
        console.log('upload catch error:', err)
        // this.trigger(Events.UploadTaskError, attachmentId, '上传服务响应超时，请稍后再试')
        break
      }
    }
  }

  // 暂停
  pause () {
    this._status = STATUS.suspend
  }

  // 取消
  cancel () {
    this._status = STATUS.cancel
    this.xhr?.abort()
  }

  destroy () {
    this.removeAllEventListener()
    this.xhr = null
  }
}

export default HttpUploader
